import { AuthGuard } from '@/guards';
import Sidebar from '@/components/Sidebar';
import { PageHeader } from '@/components/common/PageHeader';
import { useLanguage } from '@/contexts/LanguageContext';
import { GitDiff, MagnifyingGlass } from 'phosphor-react';

export default function WorkflowsPage() {
  const { t } = useLanguage();

  return (
    <AuthGuard>
      <div className="flex h-screen theme-bg overflow-hidden">
        <div className="flex-shrink-0">
          <Sidebar />
        </div>

        <main className="flex-1 min-w-0 overflow-y-auto flex flex-col">
          <PageHeader
            title={t('sidebar.workflows')}
            subtitle="Gerencie e automatize seus fluxos de trabalho com IA."
            action={
              <button
                type="button"
                className="inline-flex items-center justify-center px-4 h-8 rounded-lg text-xs font-medium transition-all cursor-pointer disabled:pointer-events-none bg-[color:var(--nt-primary)] text-white fill-white shadow-[inset_0_-0.125rem_0_0_var(--nt-primary-inset-bottom),inset_0_0.125rem_0_0_var(--nt-primary-inset-top)] hover:brightness-95 hover:shadow-[inset_0_-0.125rem_0_0_var(--nt-primary-inset-bottom-hover),inset_0_0.125rem_0_0_var(--nt-primary-inset-top-hover)]"
              >
                <svg className="inline-flex size-4 fill-inherit" width="16" height="16" viewBox="0 0 16 16">
                  <path d="M8.663 3.33l-.001 4h4.001v1.333H8.662l.001 4H7.33v-4h-4V7.33h4v-4z"></path>
                </svg>
                <span className="ml-2">Novo Workflow</span>
              </button>
            }
          />

          <div className="flex-1 p-8">
            <div className="max-w-5xl mx-auto">
              {/* Search and Filters */}
              <div className="flex items-center gap-4 mb-8">
                <div className="relative flex-1">
                  <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" size={18} />
                  <input
                    type="text"
                    placeholder="Buscar workflows..."
                    className="w-full pl-10 pr-4 py-2.5 rounded-xl border theme-border bg-white dark:bg-zinc-900/50 outline-none focus:ring-2 focus:ring-[color:var(--nt-primary)]/20 transition-all font-medium text-sm"
                  />
                </div>
              </div>

              {/* Empty State / Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Placeholder Card */}
                <div className="group relative flex flex-col p-6 rounded-2xl border theme-border bg-white dark:bg-zinc-900/50 hover:shadow-xl hover:shadow-black/5 dark:hover:shadow-none transition-all duration-300 border-dashed border-2 items-center justify-center text-center bg-transparent min-h-[200px]">
                  <div className="size-12 rounded-full bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center mb-4 text-zinc-400 group-hover:scale-110 transition-transform">
                    <GitDiff size={24} />
                  </div>
                  <h3 className="text-sm font-semibold theme-text mb-1">Crie seu primeiro workflow</h3>
                  <p className="text-xs theme-text-muted mb-4 max-w-[200px]">Automatize tarefas complexas combinando diferentes habilidades e triggers.</p>
                  <button className="text-sm font-medium text-[color:var(--nt-primary)] hover:underline">
                    Ver modelos →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </AuthGuard>
  );
}
